import { render, staticRenderFns } from "./MchPayIfConfigList.vue?vue&type=template&id=217f19be&scoped=true"
import script from "./MchPayIfConfigList.vue?vue&type=script&lang=js"
export * from "./MchPayIfConfigList.vue?vue&type=script&lang=js"
import style0 from "./MchPayIfConfigList.vue?vue&type=style&index=0&id=217f19be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217f19be",
  null
  
)

export default component.exports